import { createAsyncAction } from 'typesafe-actions';
import { Log } from 'classes/log/Log.class';

// Action pour charger les logs
export const loadAdminLogsAsync = createAsyncAction("LOAD_ADMIN_LOGS_REQUEST", "LOAD_ADMIN_LOGS_SUCCESS", "LOAD_ADMIN_LOGS_FAILURE")<
    void,
    Log[],
    string
>();